module.exports = __webpack_public_path__ + "static/media/Droper.76c3574b.svg";